import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";
import { color } from "@mui/system";

const MySelect = ({ allOption = { label: "Select all", value: "*" }, ...props }) => {
  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        options={[allOption, ...props.options]}
        onChange={(selected, event) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === allOption.value) {
              return props.onChange([allOption, ...props.options]);
            }
            let result = [];
            if (selected.length === props.options.length) {
              if (selected.includes(allOption)) {
                result = selected.filter(
                  option => option.value !== allOption.value
                );
              } else if (event.action === "select-option") {
                result = [allOption, ...props.options];
                
              // alert(result);
              }
              return props.onChange(result);
            }
          }

          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} />;
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

export default MySelect;
